import { getRequest, putRequest, patchRequest } from "./httpClient";

const END_POINT_ACCESS = "userAccess";

const getProfile = async () => {
  const response = await getRequest(`${END_POINT_ACCESS}/profile`);
  return response;  
};

const saveProfile = async (profileData) => {
  return await patchRequest(`${END_POINT_ACCESS}/profile`, profileData);
};

const setCurrentUser = async () => {
  console.log("***************user.api, setCurrentUser");
  return await putRequest(`${END_POINT_ACCESS}/current`);
};

const setCurrentProject = async (partyReference) => {
  const response = await putRequest(`${END_POINT_ACCESS}/project/${partyReference}`);
  console.log("user.api, setCurrentProject, response: ", response);
  return response;
};

export { getProfile, saveProfile, setCurrentUser, setCurrentProject };
